export default __webpack_public_path__ + "static/media/computer.a364ac06.jpg";